// extracted by mini-css-extract-plugin
export var root = "xfM8";
export var rootDescription = "fQmP";
export var rootHasChildren = "_2BMZ";
export var rootIcon = "-fIL";